import { resolveRequestInfo } from './path-resolver';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
const PUBLIC_BFF_PREFIX = '/api/bff/public';
const CLIENT_BFF_PREFIX = '/api/bff/client';
const HEARTBEAT_PATH = '/session/heartbeat';
const RENEW_PATH = '/session/renew';

const pathFromRequestInfo = (input: RequestInfo): string => {
  if (typeof input === 'string') {
    return input;
  }
  if (input instanceof URL) {
    return `${input.pathname}${input.search}`;
  }
  const url = input.url;
  if (/^https?:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);
      return `${parsed.pathname}${parsed.search}`;
    } catch {
      return url;
    }
  }
  return url;
};

/** Whether a mutating BFF request should carry X-CSRF-TOKEN from the csrf-handler. */
export function shouldAttachCsrfToken(
  method: string | undefined,
  requestInfo: RequestInfo
): boolean {
  if (!method || !MUTATING_METHODS.has(method.toUpperCase())) {
    return false;
  }

  const resolvedPath = pathFromRequestInfo(resolveRequestInfo(requestInfo));
  const pathname = resolvedPath.split('?')[0];

  if (!pathname.startsWith('/api/bff')) {
    return false;
  }
  if (pathname.startsWith(PUBLIC_BFF_PREFIX)) {
    return false;
  }
  if (pathname.startsWith(CLIENT_BFF_PREFIX)) {
    return false;
  }
  if (pathname.includes(HEARTBEAT_PATH) || pathname.includes(RENEW_PATH)) {
    return false;
  }

  return true;
};
